import { StorageKeys } from '@constants/storageKeys';
import { createStorageKey } from '@utils/storage';
import { SearchDocumentQuery, SearchDocumentSettings } from '@models/searchDocument/SearchDocument';
import { atomWithStorage } from 'jotai/utils';
import { atom } from 'jotai';

interface SearchOperators {
    [key: string]: string;
}

export const SearchOperatorsAtom = atomWithStorage<SearchOperators>(createStorageKey([StorageKeys.SearchOperators]), {});
export const SearchValuesAtom = atomWithStorage<SearchOperators>(createStorageKey([StorageKeys.SearchValues]), {});
export const SearchQueryAtom = atom<SearchDocumentQuery>({ values: [], includeCompleted: false, includeDeleted: false });
export const SearchSettingsAtom = atomWithStorage<SearchDocumentSettings>(createStorageKey([StorageKeys.SearchSettings]), { includeCompleted: false, includeDeleted: false });
